import { EventEmitter, EventSubscription } from 'fbemitter';
import { isMobile, isMobileApp } from '@/utils/general/device-info';
import { MB_customWindowForWeb, MB_BroadcastChannel } from '@/utils/general/custom-window-for-web';

const eventEmitter = new EventEmitter();
let broadcastChannel: MB_BroadcastChannel | undefined;

if (!isMobileApp) {
  broadcastChannel = new MB_customWindowForWeb.BroadcastChannel('mightybyte/broadcastChannel');
}

enum MB_EVENT_EMMITER_EVENT_TYPE {
  message = 'message',
  internal = 'internal',
  leader = 'leader',
}

interface MB_EventObject {
  origin: string;
  data: any;
}

export type TMB_EventSubscription = {
  listener(event: MB_EventObject): void;

  /**
   * Removes this subscription from the subscriber that controls it.
   */
  remove(): void;
};

const MB_EventEmmiter = {
  addListener: (
    eventType: MB_EVENT_EMMITER_EVENT_TYPE,
    listener: (event: MB_EventObject) => void,
    { context, useBroadcastChannel }: { context?: any; useBroadcastChannel?: boolean } = {}
  ): TMB_EventSubscription => {
    let mobileEventSubscription: EventSubscription | undefined;

    if (isMobile) {
      mobileEventSubscription = eventEmitter.addListener(eventType, listener, context);
    } else if (useBroadcastChannel) {
      if (broadcastChannel) {
        broadcastChannel.addEventListener('message', event => listener(event.data));
      } else {
        console.error('broadcastChannel not initialized!');
      }
    } else {
      MB_customWindowForWeb.addEventListener('message', listener);
    }

    const eventSubscription: TMB_EventSubscription = {
      listener,
      remove: () => {
        if (isMobile) {
          mobileEventSubscription?.remove();
        } else if (useBroadcastChannel) {
          if (broadcastChannel) {
            broadcastChannel.removeEventListener('message', listener);
          } else {
            console.error('broadcastChannel not initialized!');
          }
        } else {
          MB_customWindowForWeb.removeEventListener('message', listener);
        }
      },
    };

    return eventSubscription;
  },
  /**
   *
   * @param eventType
   * @param data Event data
   * @param target String base url of the website (used for web)
   */
  emit: (eventType: MB_EVENT_EMMITER_EVENT_TYPE, eventObject: MB_EventObject, { useBroadcastChannel }: { useBroadcastChannel?: boolean } = {}) => {
    if (isMobile) {
      eventEmitter.emit(eventType, eventObject);
    } else if (useBroadcastChannel) {
      if (broadcastChannel) {
        broadcastChannel.postMessage(eventObject);
      } else {
        console.error('broadcastChannel not initialized!');
      }
    } else {
      if (MB_customWindowForWeb.opener) {
        MB_customWindowForWeb.opener.postMessage(eventObject.data, eventObject.origin);
      } else {
        MB_customWindowForWeb.postMessage(eventObject.data, eventObject.origin);
      }
    }
  },
};

export { MB_EventEmmiter, MB_EVENT_EMMITER_EVENT_TYPE };
export type { MB_EventObject };
